<template>
  <v-card class="picker-card">
    <v-date-picker
      v-model="inner"
      show-adjacent-months
      color="primary"
      :min="minDate"
      :max="maxDate"
      :multiple="'range'"
    />
    <v-card-actions>
      <v-spacer />
      <v-btn variant="text" @click="$emit('cancel')">Cancelar</v-btn>
      <v-btn color="primary" variant="text" @click="$emit('applyCustomRange')">Aplicar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'RangeDatePicker',
  props: {
    modelValue: {
      type: Array as () => Date[] | null,
      required: false,
      default: null,
    },
    minDate: {
      type: String,
      required: true,
    },
    maxDate: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue', 'applyCustomRange', 'cancel'],
  setup(props, { emit }) {
    const inner = computed<Date[] | null>({
      get: () => props.modelValue,
      set: (v) => emit('update:modelValue', v),
    });

    return {
      inner,
    };
  },
});
</script>

<style scoped>
.picker-card .v-date-picker {
  margin: auto;
}
</style>
